import { createWebTracer } from 'folio-tracing-web';

await createWebTracer('bank-frontend');
